import React from "react"
import { withPrefix } from 'gatsby'

import LayoutTop from "../components/layout_top"
// import Image from "../components/image"
import SEO from "../components/seo"

const IndexPage = () => (
  <LayoutTop>
    <SEO
      title="日本商工会議所「日商簿記-1グランプリ2024」公式サイト"
      description="「日商簿記-1グランプリ2024」大会のページです。"
    />
    <div className="mainVisualBox">
      <div className="main-chara">
      </div>
    </div>
    <div className="slogo optmenu">
      {/*
      <div className="description" align="center">
        <p>参加登録受付は10月11日（金）からとなります。</p>
      </div>
      */}
      {/*
      <div id="js-entryBox" class="entryBox small">
        <div class="head">エントリー受付開始！</div>
          <div class="btn">
            <a href="/boki-1/competition_team" class="btn">
              <img src="/boki-1/images/topentry_0002_4.png" alt="ENTRY" />
            </a>
          </div>
          <div class="link"><a href="https://www.kentei.ne.jp/redirect/entry">エントリーの流れ</a>
        </div>
      </div>
      */}
      {/*
      <div id="js-entryBox" class="entryBox">
        <div class="head">エントリーは終了しました</div>
        <div class="link">
          <a href="/boki-1/entries" class="btn">＞エントリーチーム一覧はこちら</a>
        </div>
        <div className="testDate">
          試験日
          <span>2024年11月17日（日）</span>
          （第１６８回簿記検定試験）
        </div>
      </div>
      */}
      <div id="js-entryBox_" className="entryBox">
        <a href="/boki-1/ranking"><img src={withPrefix('images/resultbannar2.png')} alt="結果発表" /></a>
      </div>
      <h1>
        <img src={withPrefix('images/icon_2024.png')} alt="日本商工会議所「日商簿記-1グランプリ2024」公式サイト" />
      </h1>
    </div>
  </LayoutTop>
)

export default IndexPage
